import { render, staticRenderFns } from "./AiPhraseEditor.vue?vue&type=template&id=76e43cb7&scoped=true&"
import script from "./AiPhraseEditor.vue?vue&type=script&lang=ts&"
export * from "./AiPhraseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./AiPhraseEditor.vue?vue&type=style&index=0&id=76e43cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e43cb7",
  null
  
)

export default component.exports